import React, { useState, useEffect, useRef } from 'react';
import { KTSVG, SimpleAlert } from '../../../../../_mexablock/helpers';
import { Modal } from 'react-bootstrap-v5';
import { useFormik } from 'formik';
import {
  getStockPackage,
  removeRegisterCatalog,
} from '../../../../service/inventario/entrada&salidas';
import { ConfirmModal } from './ConfirmModal';

type Props = {
  show: boolean;
  handleClose: (updateGrid: boolean) => void;
  data: any;
};

const DetalleModal: React.FC<Props> = ({ show, data, handleClose }) => {
  const [loading, setLoading] = useState(false);
  const [initValues] = useState<{
    id_motion: number;
  }>({
    id_motion: 0,
  });
  const [filteredProducts, setFilteredProducts] = useState<any[]>([]);
  const [selectedItems, setSelectedItems] = useState<string[]>([]);
  const [pendingValues, setPendingValues] = useState<any>(null);
  const [visivilityModalConfimation, setVisivilityModalConfimation] =
    useState<boolean>(false);
  const [packageDate, setPackageDate] = useState<string>('');
  const [totalCost, setTotalCost] = useState<number>(0);
  const [typeMotion, setTypeMotion] = useState<string>('');
  const [motivo, setMotivo] = useState<string>('');
  const [accion, setAccion] = useState<string>('');
  const [user, setUser] = useState<any>();

  const formPackMovement = useFormik({
    initialValues: initValues,
    validate: (values) => {
      const errors: any = {};
      if (!values.id_motion || values.id_motion === 0) {
        errors.id_motion = 'Seleccione una acción válida.';
      }
      return errors;
    },
    enableReinitialize: true,
    onSubmit: (values) => {
      setPendingValues(values);
      setVisivilityModalConfimation(true);
    },
  });

  const fetchPostIccid = async (idPackage: number) => {
    try {
      const sends = await getStockPackage(idPackage);
      if (sends) {
        setFilteredProducts(sends);
      }
    } catch (error) {
      console.error('Error al obtener datos:', error);
    }
  };

  const onClose = () => {
    formPackMovement.resetForm();
    setFilteredProducts([]);
    setSelectedItems([]);
    setTotalCost(0);
    setUser(null);
    setPackageDate('');
    handleClose(true);
  };

  useEffect(() => {
    if (show) {
      fetchPostIccid(data?.id);

      if (data?.createdAt) {
        setPackageDate(new Date(data.createdAt).toLocaleDateString('es-ES'));
      } else {
        setPackageDate('');
      }
      if (data.creator) {
        const fullName = `${data?.creator?.first_name || ''} ${
          data?.creator?.father_last_name || ''
        } ${data?.creator?.mother_last_name || ''}`.trim();
        setUser(fullName || 'Sin nombre');
      }
      if (data?.package?.id) {
        formPackMovement.setFieldValue('package_id', data.package.id);
      }
      if (data?.id) {
        formPackMovement.setFieldValue('id_motion', data.id);
      }
      if (data.detail) {
        setMotivo(data.detail);
      }
      if (data.price) {
        setTotalCost(Number(data.price));
      }
      if (data.motive_name) {
        setTypeMotion(data.motive_name);
      }
      if (data.is_output) {
        setAccion('Asignar');
      } else {
        setAccion('Devolver');
      }
    }
  }, [show]);

  return (
    <Modal
      id="kt_modal_create"
      tabIndex={-1}
      aria-hidden="true"
      dialogClassName="modal-dialog modal-dialog-centered modal-lg"
      show={show}
      onHide={onClose}
    >
      <div className="modal-content">
        <div className="modal-header pb-0 border-0 justify-content-end">
          <div
            className="btn btn-sm btn-icon btn-active-color-primary"
            data-bs-dismiss="modal"
            onClick={() => {
              formPackMovement.resetForm();
              handleClose(false);
            }}
          >
            <KTSVG
              className="svg-icon-2"
              path="/media/icons/duotune/arrows/arr061.svg"
            />
          </div>
        </div>

        <div className="modal-body scroll-y mx-5 pt-0">
          <div className="text-center mb-13">
            <h1 className="mb-3">Detalles de devolución</h1>
            <div className="text-muted fw-semibold fs-5 w-75 mx-auto text-center">
              Vea los detalles de la devolución o cancele la orden para regresar
              las unidades nuevamente al inventario
            </div>
          </div>
          <form
            id="kt_modal_generic_form"
            className="form"
            action="#"
            onSubmit={(e) => e.preventDefault()}
          >
            <div className="w-100 container">
              <div className="row justify-content-center">
                {/* Detalles de devolución */}
                <div className="col-7 border border-gray-500 min-h-600px p-5 rounded">
                  <span className="fw-bolder fs-5 text-gray-600">
                    Detalles de devolución
                  </span>

                  <div className="separator border-2 my-4" />

                  {/* Acción */}
                  <div className="mb-4">
                    <label className=" fw-bold fs-6 mb-2">Acción</label>
                    <input
                      type="text"
                      className="form-control"
                      value={accion}
                      disabled
                    />
                  </div>

                  {/* Tipo */}
                  <div className="mb-4">
                    <label className=" fw-bold fs-6 mb-2">Razón</label>

                    <input
                      type="text"
                      className="form-control"
                      value={typeMotion || 'Sin nombre'}
                      disabled
                    />
                  </div>

                  {/* Usuario y Fecha */}
                  <div className="row mb-4">
                    <div className="col">
                      <label className="fw-bold fs-6 mb-2">Usuario</label>
                      <input
                        type="text"
                        className="form-control"
                        value={user || 'Sin tipo'}
                        disabled
                      />
                    </div>
                    <div className="col">
                      <label className="fw-bold fs-6 mb-2">Fecha</label>
                      <input
                        type="text"
                        className="form-control"
                        value={packageDate}
                        disabled
                      />
                    </div>
                  </div>

                  {/* Motivo */}
                  <div className="mb-4">
                    <label className=" fw-bold fs-6 mb-2">Motivo</label>
                    <textarea
                      className="form-control h-150px"
                      placeholder="Descripción"
                      value={motivo}
                      disabled
                    />
                  </div>

                  {/* Costo */}
                  {/* <div className="w-50">
                    <label className="fw-bold fs-6 mb-2">Costo</label>
                    <input
                      type="text"
                      className="form-control"
                      value={totalCost.toLocaleString('es-MX', {
                        style: 'currency',
                        currency: 'MXN',
                      })}
                      disabled
                    />
                  </div> */}
                </div>

                {/* Selección de productos */}
                <div className="col-4 border border-gray-500 min-h-600px ms-4 p-5 rounded">
                  <span className="fw-bolder fs-5 text-gray-600">
                    Productos seleccionados
                  </span>
                  <div className="separator border-2 my-4" />

                  {/* Tabla de productos */}
                  <div
                    className="table-responsive"
                    style={{ maxHeight: '400px', overflowY: 'auto' }}
                  >
                    <table className="table align-middle table-row-dashed fs-6 gy-3">
                      <thead>
                        <tr className="text-start text-muted fw-bold fs-7 text-uppercase gs-0">
                          <th scope="col">ICCID</th>
                        </tr>
                      </thead>
                      <tbody>
                        {filteredProducts.map((item: any) => (
                          <tr key={item.id}>
                            <td>{item?.stock?.iccid}</td>
                          </tr>
                        ))}
                      </tbody>
                    </table>
                  </div>
                </div>
              </div>
            </div>
            <div className="d-flex justify-content-end mt-10">
              {/* <button
                type="button"
                onClick={() => {
                  const errors = formPackMovement.validateForm();
                  formPackMovement.validateForm().then((errors) => {
                    if (Object.keys(errors).length === 0) {
                      setPendingValues(formPackMovement.values);
                      setVisivilityModalConfimation(true);
                    } else {
                      formPackMovement.setTouched({
                        id_motion: true,
                      });
                    }
                  });
                }}
                disabled={loading}
                className="btn btn-primary"
              >
                Cancelar devolución
              </button> */}
              <button
                type="reset"
                className="btn btn-primary me-3"
                data-kt-users-modal-action="cancel"
                onClick={onClose}
              >
                Aceptar
              </button>
            </div>
          </form>
        </div>
      </div>
      <ConfirmModal
        show={visivilityModalConfimation}
        confirmValue={async (updateData: boolean) => {
          if (updateData && pendingValues) {
            setLoading(true);
            try {
              const res = await removeRegisterCatalog(pendingValues.id_motion);
              const {
                data: { message },
              } = res;
              SimpleAlert(message, 3000, 'success');
              handleClose(true);
            } catch (err: any) {
              let resMessageToast: string = 'Ocurrió un error inesperado.';
              if (err.response && err.response.data) {
                const { message, details = null } = err.response.data;
                resMessageToast = `${message}`;
                if (details && Array.isArray(details) && details.length) {
                  resMessageToast = `${details[0].message}`;
                }
              } else if (err.message) {
                resMessageToast = err.message;
              }
              SimpleAlert(resMessageToast, 3000, 'error');
            }
            setLoading(false);
          }
          setVisivilityModalConfimation(false);
        }}
        onClose={() => {
          setVisivilityModalConfimation(false);
        }}
      />
    </Modal>
  );
};
export { DetalleModal };
